// Specialty metadata derived from the NGAP Maroc dataset.
// Used by Cotations to render top-level tabs.
import { NGAP_BY_SPECIALTY, type NGAPAct } from "./ngap-maroc-codes";

export type NgapSpecialtyMeta = {
  id: string;
  label: string;
  short: string;
  scope: string;
  doctorSpecs: string[];
};

export const SPECIALTY_META: NgapSpecialtyMeta[] = [
  { id: "medecine-generale", label: "Médecine générale", short: "Méd. générale", scope: "Consultations, visites, soins courants", doctorSpecs: ["Médecine interne", "Médecine générale", "Pédiatrie"] },
  { id: "urgences", label: "Urgences", short: "Urgences", scope: "Actes d'urgence et réanimation", doctorSpecs: ["Médecine d'urgence", "Réanimation"] },
  { id: "chirurgie-orthopedique", label: "Chirurgie orthopédique", short: "Orthopédie", scope: "Traumatologie & ostéosynthèse", doctorSpecs: ["Chirurgie orthopédique", "Traumatologie"] },
  { id: "chirurgie-viscerale", label: "Chirurgie viscérale", short: "Chir. viscérale", scope: "Chirurgie digestive et viscérale", doctorSpecs: ["Chirurgie générale", "Chirurgie viscérale"] },
  { id: "neurochirurgie", label: "Neurochirurgie", short: "Neurochirurgie", scope: "Crâne, rachis, nerfs périphériques", doctorSpecs: ["Neurochirurgie"] },
  { id: "urologie", label: "Urologie", short: "Urologie", scope: "Appareil urinaire et génital masculin", doctorSpecs: ["Urologie"] },
  { id: "gynecologie", label: "Gynécologie-Obstétrique", short: "Gynéco-Obst.", scope: "Gynécologie & obstétrique", doctorSpecs: ["Gynécologie-Obstétrique"] },
  { id: "orl", label: "ORL", short: "ORL", scope: "Oto-rhino-laryngologie", doctorSpecs: ["ORL"] },
  { id: "dermatologie", label: "Dermatologie", short: "Dermato.", scope: "Peau et phanères", doctorSpecs: ["Dermatologie"] },
  { id: "pneumologie", label: "Pneumologie", short: "Pneumo.", scope: "Appareil respiratoire", doctorSpecs: ["Pneumologie"] },
  { id: "nephrologie", label: "Néphrologie", short: "Néphro.", scope: "Reins, dialyse, transplantation", doctorSpecs: ["Néphrologie"] },
  { id: "radiologie", label: "Radiologie", short: "Radiologie", scope: "Imagerie médicale", doctorSpecs: ["Radiologie"] },
  { id: "radiotherapie", label: "Radiothérapie", short: "Radiothérapie", scope: "Radiothérapie & curiethérapie", doctorSpecs: ["Radiothérapie", "Oncologie"] },
  { id: "biologie", label: "Biologie médicale", short: "Biologie", scope: "Analyses de laboratoire", doctorSpecs: ["Biologie médicale"] },
  { id: "kinesitherapie", label: "Kinésithérapie", short: "Kiné.", scope: "Rééducation fonctionnelle", doctorSpecs: ["Kinésithérapie"] },
];

export type SpecialtyWithCounts = NgapSpecialtyMeta & {
  count: number;
  subSpecialties: { id: string; count: number }[];
};

export const SPECIALTIES: SpecialtyWithCounts[] = SPECIALTY_META
  .filter((s) => NGAP_BY_SPECIALTY[s.id])
  .map((s) => {
    const codes = NGAP_BY_SPECIALTY[s.id] ?? [];
    const subs = new Map<string, number>();
    for (const c of codes) {
      const k = c.sub_specialty || "Général";
      subs.set(k, (subs.get(k) ?? 0) + 1);
    }
    return {
      ...s,
      count: codes.length,
      subSpecialties: [...subs.entries()].map(([id, count]) => ({ id, count })),
    };
  });

export function codesFor(specialtyId: string, subSpecialty?: string | null): NGAPAct[] {
  const all = NGAP_BY_SPECIALTY[specialtyId] ?? [];
  if (!subSpecialty || subSpecialty === "all") return all;
  return all.filter((c) => (c.sub_specialty || "Général") === subSpecialty);
}
